export default __webpack_public_path__ + "static/media/crown.c4384d7a.png";